import { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { getTikTokFollowWelcomeState } from 'apps/tiktokFollowWelcome/adapter'
import { TikTokFollowWelcomeState } from 'apps/tiktokFollowWelcome/interfaces'
import { NAMESPACE } from 'apps/tiktokFollowWelcome/store/constants'
import { tiktokApi } from 'shared/api/requests/tiktok'
import { createAsyncAction } from 'shared/lib/redux'

export const loadTikTokFlow = createAsyncAction(`${NAMESPACE}/loadFlow`, async () => {
  const flowData = await tiktokApi.tikTokFollowReply.getData()

  return flowData.data
})

export const loadTikTokFlowReducer = (
  builder: ActionReducerMapBuilder<TikTokFollowWelcomeState>,
) => {
  builder.addCase(loadTikTokFlow.fulfilled, (state, action) => ({
    ...state,
    ...getTikTokFollowWelcomeState(action.payload),
  }))
}
